var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 150,
    viewBox: "0 0 320 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7231",
    "data-name": "Groupe 7231",
    transform: "translate(-150 -128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    transform: "translate(150 128)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 150,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 319.7,
    height: 149.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-image",
    "data-name": "Icon feather-image",
    transform: "translate(167.559 152.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10191",
    "data-name": "Trac\\xE9 10191",
    d: "M15.507,3H85.934A12.522,12.522,0,0,1,98.441,15.507V85.934A12.521,12.521,0,0,1,85.934,98.441H15.507A12.522,12.522,0,0,1,3,85.934V15.507A12.522,12.522,0,0,1,15.507,3ZM85.934,93.549a7.623,7.623,0,0,0,7.615-7.615V15.507a7.623,7.623,0,0,0-7.615-7.615H15.507a7.623,7.623,0,0,0-7.615,7.615V85.934a7.623,7.623,0,0,0,7.615,7.615Z",
    transform: "translate(0 0)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10192",
    "data-name": "Trac\\xE9 10192",
    d: "M18.992,9A9.992,9.992,0,1,1,9,18.992,10,10,0,0,1,18.992,9Zm0,15.091a5.1,5.1,0,1,0-5.1-5.1A5.105,5.105,0,0,0,18.992,24.091Z",
    transform: "translate(14.122 14.122)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10193",
    "data-name": "Trac\\xE9 10193",
    d: "M8.446,73.728a2.446,2.446,0,0,1-1.73-4.176L62.052,14.217a2.446,2.446,0,0,1,3.46,0L90.664,39.369a2.446,2.446,0,0,1-3.46,3.46L63.782,19.406,10.176,73.012A2.439,2.439,0,0,1,8.446,73.728Z",
    transform: "translate(7.061 24.713)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-image-2",
    "data-name": "Icon feather-image",
    transform: "translate(285.559 155.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10191-2",
    "data-name": "Trac\\xE9 10191",
    d: "M9.111,3H43.518a6.117,6.117,0,0,1,6.111,6.111V43.518a6.117,6.117,0,0,1-6.111,6.11H9.111A6.117,6.117,0,0,1,3,43.518V9.111A6.117,6.117,0,0,1,9.111,3ZM43.518,47.238a3.724,3.724,0,0,0,3.72-3.72V9.111a3.724,3.724,0,0,0-3.72-3.72H9.111a3.724,3.724,0,0,0-3.72,3.72V43.518a3.724,3.724,0,0,0,3.72,3.72Z",
    transform: "translate(-3 -3)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10192-2",
    "data-name": "Trac\\xE9 10192",
    d: "M13.882,9A4.882,4.882,0,1,1,9,13.882,4.887,4.887,0,0,1,13.882,9Zm0,7.373a2.491,2.491,0,1,0-2.491-2.491A2.494,2.494,0,0,0,13.882,16.373Z",
    transform: "translate(0.831 0.831)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10193-2",
    "data-name": "Trac\\xE9 10193",
    d: "M7.2,42.925a1.2,1.2,0,0,1-.845-2.04L33.384,13.85a1.2,1.2,0,0,1,1.69,0L47.363,26.138a1.2,1.2,0,0,1-1.69,1.69L34.23,16.385,8.04,42.575A1.191,1.191,0,0,1,7.2,42.925Z",
    transform: "translate(-1.085 3.704)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-image-3",
    "data-name": "Icon feather-image",
    transform: "translate(285.559 204.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10191-3",
    "data-name": "Trac\\xE9 10191",
    d: "M9.111,3H43.518a6.117,6.117,0,0,1,6.111,6.111V43.518a6.117,6.117,0,0,1-6.111,6.11H9.111A6.117,6.117,0,0,1,3,43.518V9.111A6.117,6.117,0,0,1,9.111,3ZM43.518,47.238a3.724,3.724,0,0,0,3.72-3.72V9.111a3.724,3.724,0,0,0-3.72-3.72H9.111a3.724,3.724,0,0,0-3.72,3.72V43.518a3.724,3.724,0,0,0,3.72,3.72Z",
    transform: "translate(-3 -2.999)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10192-3",
    "data-name": "Trac\\xE9 10192",
    d: "M13.882,9A4.882,4.882,0,1,1,9,13.882,4.887,4.887,0,0,1,13.882,9Zm0,7.373a2.491,2.491,0,1,0-2.491-2.491A2.494,2.494,0,0,0,13.882,16.373Z",
    transform: "translate(0.831 0.831)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10193-3",
    "data-name": "Trac\\xE9 10193",
    d: "M7.2,42.925a1.2,1.2,0,0,1-.845-2.04L33.384,13.85a1.2,1.2,0,0,1,1.69,0L47.363,26.138a1.2,1.2,0,0,1-1.69,1.69L34.23,16.385,8.04,42.575A1.191,1.191,0,0,1,7.2,42.925Z",
    transform: "translate(-1.085 3.704)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-image-4",
    "data-name": "Icon feather-image",
    transform: "translate(342.187 155.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10191-4",
    "data-name": "Trac\\xE9 10191",
    d: "M9.111,3H43.518a6.117,6.117,0,0,1,6.111,6.111V43.518a6.117,6.117,0,0,1-6.111,6.11H9.111A6.117,6.117,0,0,1,3,43.518V9.111A6.117,6.117,0,0,1,9.111,3ZM43.518,47.238a3.724,3.724,0,0,0,3.72-3.72V9.111a3.724,3.724,0,0,0-3.72-3.72H9.111a3.724,3.724,0,0,0-3.72,3.72V43.518a3.724,3.724,0,0,0,3.72,3.72Z",
    transform: "translate(-3 -3)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10192-4",
    "data-name": "Trac\\xE9 10192",
    d: "M13.882,9A4.882,4.882,0,1,1,9,13.882,4.887,4.887,0,0,1,13.882,9Zm0,7.373a2.491,2.491,0,1,0-2.491-2.491A2.494,2.494,0,0,0,13.882,16.373Z",
    transform: "translate(0.831 0.831)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10193-4",
    "data-name": "Trac\\xE9 10193",
    d: "M7.2,42.925a1.2,1.2,0,0,1-.845-2.04L33.384,13.85a1.2,1.2,0,0,1,1.69,0L47.363,26.138a1.2,1.2,0,0,1-1.69,1.69L34.23,16.385,8.04,42.575A1.191,1.191,0,0,1,7.2,42.925Z",
    transform: "translate(-1.085 3.704)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-image-5",
    "data-name": "Icon feather-image",
    transform: "translate(342.187 204.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10191-5",
    "data-name": "Trac\\xE9 10191",
    d: "M9.111,3H43.518a6.117,6.117,0,0,1,6.111,6.111V43.518a6.117,6.117,0,0,1-6.111,6.11H9.111A6.117,6.117,0,0,1,3,43.518V9.111A6.117,6.117,0,0,1,9.111,3ZM43.518,47.238a3.724,3.724,0,0,0,3.72-3.72V9.111a3.724,3.724,0,0,0-3.72-3.72H9.111a3.724,3.724,0,0,0-3.72,3.72V43.518a3.724,3.724,0,0,0,3.72,3.72Z",
    transform: "translate(-3 -2.999)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10192-5",
    "data-name": "Trac\\xE9 10192",
    d: "M13.882,9A4.882,4.882,0,1,1,9,13.882,4.887,4.887,0,0,1,13.882,9Zm0,7.373a2.491,2.491,0,1,0-2.491-2.491A2.494,2.494,0,0,0,13.882,16.373Z",
    transform: "translate(0.831 0.831)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10193-5",
    "data-name": "Trac\\xE9 10193",
    d: "M7.2,42.925a1.2,1.2,0,0,1-.845-2.04L33.384,13.85a1.2,1.2,0,0,1,1.69,0L47.363,26.138a1.2,1.2,0,0,1-1.69,1.69L34.23,16.385,8.04,42.575A1.191,1.191,0,0,1,7.2,42.925Z",
    transform: "translate(-1.085 3.704)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-image-6",
    "data-name": "Icon feather-image",
    transform: "translate(399.187 155.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10191-6",
    "data-name": "Trac\\xE9 10191",
    d: "M9.111,3H43.518a6.117,6.117,0,0,1,6.111,6.111V43.518a6.117,6.117,0,0,1-6.111,6.11H9.111A6.117,6.117,0,0,1,3,43.518V9.111A6.117,6.117,0,0,1,9.111,3ZM43.518,47.238a3.724,3.724,0,0,0,3.72-3.72V9.111a3.724,3.724,0,0,0-3.72-3.72H9.111a3.724,3.724,0,0,0-3.72,3.72V43.518a3.724,3.724,0,0,0,3.72,3.72Z",
    transform: "translate(-3 -3)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10192-6",
    "data-name": "Trac\\xE9 10192",
    d: "M13.882,9A4.882,4.882,0,1,1,9,13.882,4.887,4.887,0,0,1,13.882,9Zm0,7.373a2.491,2.491,0,1,0-2.491-2.491A2.494,2.494,0,0,0,13.882,16.373Z",
    transform: "translate(0.831 0.831)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10193-6",
    "data-name": "Trac\\xE9 10193",
    d: "M7.2,42.925a1.2,1.2,0,0,1-.845-2.04L33.384,13.85a1.2,1.2,0,0,1,1.69,0L47.363,26.138a1.2,1.2,0,0,1-1.69,1.69L34.23,16.385,8.04,42.575A1.191,1.191,0,0,1,7.2,42.925Z",
    transform: "translate(-1.085 3.704)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-image-7",
    "data-name": "Icon feather-image",
    transform: "translate(399.187 204.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10191-7",
    "data-name": "Trac\\xE9 10191",
    d: "M9.111,3H43.518a6.117,6.117,0,0,1,6.111,6.111V43.518a6.117,6.117,0,0,1-6.111,6.11H9.111A6.117,6.117,0,0,1,3,43.518V9.111A6.117,6.117,0,0,1,9.111,3ZM43.518,47.238a3.724,3.724,0,0,0,3.72-3.72V9.111a3.724,3.724,0,0,0-3.72-3.72H9.111a3.724,3.724,0,0,0-3.72,3.72V43.518a3.724,3.724,0,0,0,3.72,3.72Z",
    transform: "translate(-3 -2.999)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10192-7",
    "data-name": "Trac\\xE9 10192",
    d: "M13.882,9A4.882,4.882,0,1,1,9,13.882,4.887,4.887,0,0,1,13.882,9Zm0,7.373a2.491,2.491,0,1,0-2.491-2.491A2.494,2.494,0,0,0,13.882,16.373Z",
    transform: "translate(0.831 0.831)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10193-7",
    "data-name": "Trac\\xE9 10193",
    d: "M7.2,42.925a1.2,1.2,0,0,1-.845-2.04L33.384,13.85a1.2,1.2,0,0,1,1.69,0L47.363,26.138a1.2,1.2,0,0,1-1.69,1.69L34.23,16.385,8.04,42.575A1.191,1.191,0,0,1,7.2,42.925Z",
    transform: "translate(-1.085 3.704)",
    fill: "#b5b5b5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection4);
export default __webpack_public_path__ + "static/media/section4.b5a49a98ed87fd47cb3dbb69471ad0dc.svg";
export { ForwardRef as ReactComponent };